import { PinInput, escapeHtml, cssUrl, requireImageUrl } from "./types";

// Board covers are SQUARE (Pinterest crops board thumbnails to 1:1), unlike
// the 2:3 pins. The renderer is given this size explicitly.
export const BOARD_COVER_SIZE = 1000;

// boardCover — a clean, editorial cover image for a Pinterest BOARD (not a
// pin). One background photo, a soft dark scrim, the board name centered in
// serif caps between two hairline rules, and the venue's name as a small
// kicker. Generating a cohesive set of these makes a client's profile read
// as professionally managed — a high-visibility perceived-value win.
//   title → board name ("Real Weddings", "Tablescapes")
//   brand → venue name kicker
export function boardCoverTemplate(input: PinInput): string {
  const { brand, title, typography } = input;
  const imageUrl = requireImageUrl(input, "boardCover");
  const name = (title && title.trim()) || "Inspiration";

  const len = name.length;
  const nameSize = len <= 12 ? 92 : len <= 20 ? 76 : len <= 30 ? 60 : 50;

  return `<!doctype html>
<html><head>
<meta charset="utf-8" />
<link rel="preconnect" href="https://fonts.googleapis.com" />
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
<link rel="stylesheet" href="${typography.googleFontsHref}" />
<style>
  *{margin:0;padding:0;box-sizing:border-box}
  html,body{width:${BOARD_COVER_SIZE}px;height:${BOARD_COVER_SIZE}px;font-family:${typography.bodyFont};-webkit-font-smoothing:antialiased;background:#000}
  .cover{position:relative;width:100%;height:100%;overflow:hidden}
  .image{position:absolute;inset:0;background-image:url('${cssUrl(imageUrl)}');background-size:cover;background-position:center}
  /* Even darken so caps text reads anywhere, a touch deeper at the edges. */
  .image::after{content:"";position:absolute;inset:0;background:radial-gradient(ellipse 100% 100% at 50% 50%,rgba(0,0,0,.34) 0%,rgba(0,0,0,.5) 100%)}
  .inner{position:absolute;inset:0;z-index:2;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:80px 64px;color:#fff}
  .rule{width:64px;height:2px;background:rgba(255,255,255,.85);margin:0 auto}
  .name{font-family:${typography.headlineFont};font-weight:${typography.headlineWeight};text-transform:uppercase;font-size:${nameSize}px;line-height:1.06;letter-spacing:2px;margin:24px 0;text-shadow:0 2px 16px rgba(0,0,0,.45);display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}
  .kicker{position:absolute;bottom:54px;left:0;right:0;z-index:2;text-align:center;color:#fff;font-size:22px;font-weight:600;letter-spacing:4px;text-transform:uppercase;text-shadow:0 2px 10px rgba(0,0,0,.5)}
</style></head>
<body><div class="cover">
  <div class="image"></div>
  <div class="inner">
    <div class="rule"></div>
    <div class="name">${escapeHtml(name)}</div>
    <div class="rule"></div>
  </div>
  <div class="kicker">${escapeHtml(brand)}</div>
</div></body></html>`;
}
